import { FC } from 'react';

import Modal from 'react-modal';

import { DatePickerInterval, formatDate } from './utils';

interface DatePickerModalProps {
  onClick?: (value: Date) => void;
  title?: string;
  interval?: DatePickerInterval;
  dates?: Date[];
  value?: Date;
  open?: boolean;
  onClose?: () => void;
  dateFormat?: string;
}

const MODAL_STYLE = {
  content: {
    padding: 0,
    top: '50%',
    left: 'calc(50% - 8px)',
    transform: 'translate(-50%, -50%)',
    height: '400px',
    maxHeight: '80%',
    // width: 'calc(100% - 48px)',
    borderRadius: '5px',
    border: '3px solid #ff1dfc',
    boxShadow: '6px 4px 0px 0px #8052ff',
  },
};

const DatePickerModal: FC<DatePickerModalProps> = ({
  onClick,
  title,
  interval = 'day',
  dates = [],
  open = false,
  value,
  onClose,
  dateFormat,
}) => {
  let displayDate;
  if (value)
    displayDate = formatDate(value, {
      dateFormat,
      interval,
    });

  return (
    <Modal
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-10"
      style={MODAL_STYLE}
      isOpen={open}
      onRequestClose={onClose}
    >
      <div className="flex justify-between py-4 mx-4">
        <h2 className="text-lg">
          {title || 'Select date'} {displayDate ? ` - ${displayDate}` : ''}
        </h2>
        <button className="underline" onClick={onClose}>
          Cancel
        </button>
      </div>

      <ul className="h-full overflow-y-auto divide-y-2 divide-gray-100">
        {dates.map((date, i) => {
          const label = formatDate(date, {
            dateFormat,
            interval,
          });
          return (
            <li
              key={`date-option-${i}`}
              className="px-4 py-2 text-lg text-gray-500 cursor-pointer hover:bg-gray-50"
              onClick={onClick ? () => onClick(date) : undefined}
              style={
                displayDate === label
                  ? {
                      color: '#8052ff',
                    }
                  : {}
              }
            >
              {label}
            </li>
          );
        })}
      </ul>
    </Modal>
  );
};

export default DatePickerModal;
